import React from "react";
import Banner from "../../../components/Bannersection/banner";
import { Helmet } from "react-helmet";
import { BsGraphUp } from "react-icons/bs";
import { FaLock, FaKey, FaUsers, FaBuilding, FaCode } from "react-icons/fa";
import Faq from "../../../components/Faq/faq";
import Boxcard from "../../../components/Cardesection/boxcard";
import PricingSection from "../../../components/PricingSection/PricingSection";

const pagename = [
  {
    pagetitle: "WeCaaS",
    subtitle: "Website-as-a-Service for Modern Businesses",
  },
];

const faqitem = [
  {
    Faq_id: "collapseone",
    data_bs_target: "#collapseone",
    question: "Can I change plans later?",
    answer: "Yes! You can upgrade or downgrade your plan at any time. Changes take effect immediately.",
  },
  {
    Faq_id: "collapsetwo",
    data_bs_target: "#collapsetwo",
    question: "What happens if I exceed my API limits?",
    answer: "We'll notify you when you're approaching your limit. On Pro plans, additional API calls are billed at a small overage rate.",
  },
  {
    Faq_id: "collapseThree",
    data_bs_target: "#collapseThree",
    question: "Do you offer a free trial for paid plans?",
    answer: "Yes, all paid plans come with a 14-day free trial. No credit card required to start.",
  },
  {
    Faq_id: "collapsefour",
    data_bs_target: "#collapsefour",
    question: "Is there a discount for annual billing?",
    answer: "Yes, you save 20% when you choose annual billing on Pro and Enterprise plans.",
  },
  {
    Faq_id: "collapsefive",
    data_bs_target: "#collapsefive",
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards, PayPal, and bank transfers for Enterprise customers.",
  },
];

function WeCaaS() {
  const wecaasFeatures = [
    {
      icons: FaCode,
      title: "Fully Managed Websites",
      description: "We handle everything from design and development to hosting and maintenance. You focus on your business.",
    },
    {
      icons: FaBuilding,
      title: "Scalable Cloud Hosting",
      description: "High-performance cloud infrastructure ensures your website is fast, secure, and always accessible.",
    },
    {
      icons: FaLock,
      title: "Enterprise-Grade Security",
      description: "Built-in SSL, DDoS protection, and regular security audits to keep your data and users safe.",
    },
    {
      icons: FaKey,
      title: "Custom Domain & Email",
      description: "Professional online presence with custom domains and business email addresses included.",
    },
    {
      icons: FaUsers,
      title: "Dedicated Support",
      description: "Access to our expert team for regular updates, content changes, and technical assistance.",
    },
    {
      icons: BsGraphUp,
      title: "SEO & Performance",
      description: "Optimised for search engines and lightning-fast loading speeds to drive more traffic and conversions.",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>WeCaaS - Website-as-a-Service | Cloud Solutions | DGi WORX Australia</title>
        <meta
          name="description"
          content="Transform your digital presence with WeCaaS. Our Website-as-a-Service and cloud hosting solutions offer custom, scalable, and fully managed websites for Australian businesses."
        />
        <meta property="og:url" content="https://dgiworx.com.au/wecaas" />
        <link rel="canonical" href="https://dgiworx.com.au/wecaas" />
        <link rel="alternate" hreflang="en-au" href="https://dgiworx.com.au/" />
      </Helmet>

      <Banner items={pagename} />
      <h1 className="d-none">WeCaaS - Modern Website-as-a-Service Platform and Cloud Solutions</h1>

      <section className="about-area tp-about-two py-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="tp-about-two-wrap mt-10 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-about-two-thumb">
                  <div className="tp-about-circle">
                    <div className="tp-about-circle-two">
                      <img
                        src="/assets/img/product/wecaas.webp"
                        alt="WeCaaS Platform"
                        loading="lazy"
                        onError={(e) => { e.target.src = "/assets/img/product/wecass.webp"; }}
                        style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="tp-about-two-thumb-shape tp-thumb-common fix">
                  <div className="tp-thumb-common-overlay wow"></div>
                  <img src="/assets/img/product/wecass.webp" alt="" loading="lazy" />
                </div>
                <div className="tp-about-two-thumb-shape-two d-none d-md-block">
                  <img src="/assets/img/about/two/dote.png" alt="" loading="lazy" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tp-about-two-wrapper mb-10 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-section mb-40">
                  <span className="tp-section-sub-title">WEBSITE-AS-A-SERVICE</span>
                  <h2 className="tp-section-title">Website-as-a-Service for Modern Businesses.</h2>
                  <div className="tp-section-title-wrapper">
                    <p>
                      Get your business online effortlessly with our fully managed Website-as-a-Service platform.
                      We handle the technical complexities â€” from development and cloud hosting to security and ongoing maintenance.
                      Empower your brand with a stunning, high-performance website while saving time and resources.
                    </p>
                  </div>
                </div>
                <div>
                  <ul className="tp-about-one-list">
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>End-to-End Management</strong> â€“ Design, launch, and maintenance all handled for you.
                    </li>
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>Cloud-Powered Reliability</strong> â€“ Fast, secure, and scalable hosting infrastructure.
                    </li>
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>Always Up-to-Date</strong> â€“ Continuous updates and dedicated technical support.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-about-two-shape">
          <div className="tp-about-two-shape-4">
            <img src="/assets/img/about/two/about-2-shape-2.png" alt="" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="feature-area py-50 p-relative">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="tp-section text-center mb-50">
                <span className="tp-section-sub-title">FEATURES</span>
                <h2 className="tp-section-title">Everything you need for your online presence</h2>
                <p className="col-lg-10 mx-auto">
                  WeCaaS provides a comprehensive suite of tools and services to run your website effortlessly.
                </p>
              </div>
            </div>
          </div>
          <Boxcard item={wecaasFeatures} />
        </div>
        <div className="tp-feature-shape">
          <div className="tp-feature-shape-one w-img">
            <img src="/assets/img/feature/one/features-bg.png" alt="Elevating Possibilities" loading="lazy" />
          </div>
        </div>
      </section>

      {/* <PricingSection productKey="wecaas" title="WeCaaS Plans & Pricing" /> */}
      <Faq items={faqitem} />
    </div>
  );
}

export default WeCaaS;
